document.addEventListener('DOMContentLoaded', () => {

    const CONSENT_MESSAGE = 'Необходимо дать согласие на обработку персональных данных'
    const forms = document.querySelectorAll('[data-role="form-validate"]')

    for (let i = 0; i < forms.length; i++) {
        formInit(forms[i])
    }

    function formInit(form) {
        const phone = form.querySelector('[data-role="form-input-phone"]')
        const name = form.querySelector('[data-role="form-input-name"]')
        const consent = form.querySelector('[data-role="form-input-consent"]')
        const consentNotice = form.querySelector('[data-role="form-consent-notice"]')

        phone.addEventListener('input', removeError)
        form.addEventListener('submit', validate)

        const maskPhone = new IMask(phone, {mask: '+{7} (000) 000-00-00'});
        const maskName = new IMask(name, {mask: /^[А-ЯЁa-zA-Z\s]+$/i});

        if (consent) {
            consent.addEventListener('change', () => {
                consent.classList.remove('input-error')
                hideConsentNotice()
            })
        }

        form.querySelectorAll('.form-consent a').forEach((link) => {
            link.addEventListener('click', (e) => {
                e.stopPropagation()
            })
        })

        function removeError() {
            this.classList.remove('input-error')
        }

        function showConsentNotice() {
            if (!consentNotice) {
                alert(CONSENT_MESSAGE)
                return
            }
            consentNotice.textContent = CONSENT_MESSAGE
            consentNotice.classList.add('is-visible')
        }

        function hideConsentNotice() {
            if (consentNotice) {
                consentNotice.classList.remove('is-visible')
            }
        }

        function validate(e) {
            e.preventDefault()

            if (consent && !consent.checked) {
                consent.classList.add('input-error')
                showConsentNotice()
                consent.focus()
                return
            }

            hideConsentNotice()

            if (maskPhone.unmaskedValue.length < 11) {
                phone.classList.add('input-error')
            } else {
                fetchForm()
            }
        }

        async function fetchForm() {
            const url = form.getAttribute('action')
            const formData = new FormData(form);

            if (typeof BX !== 'undefined' && typeof BX.bitrix_sessid === 'function') {
                formData.set('sessid', BX.bitrix_sessid());
            }

            await fetch(url, {
                method: 'POST',
                body: formData,
            })
                .then(res => {
                    return res.json()
                })
                .then(data => {
                    success()
                })
                .catch(() => {
                    console.log('error')
                })
            
            success()

            function success() {
                console.log('success')
                closeModalForm(form)
                showKuzovSuccess(form)
                if (form.getAttribute('data-form') !== 'exclude') {
                    openThanks()
                }
                phone.value = ''
                name.value = ''
                if (consent) {
                    consent.checked = false
                    consent.classList.remove('input-error')
                }
                hideConsentNotice()

                const fileInput = form.querySelector('.feedback__input-file')
                const fileLabel = form.querySelector('.placeholder-file')
                if (fileInput) {
                    fileInput.value = ''
                }
                if (fileLabel) {
                    fileLabel.textContent = 'Прикрепите до 5 фото'
                }
            }
        }
    }

    function showKuzovSuccess(form) {
        const kuzovWrap = form.closest('.feedback__kuzovnoy-form')
        if (!kuzovWrap) {
            return
        }
        const modalSuccess = kuzovWrap.querySelector('.feedback__form-kuzov__modal-successful')
        form.style.display = 'none'
        if (modalSuccess) {
            modalSuccess.style.display = 'flex'
        }
    }

    function closeModalForm(node) {
        const fancyboxContent = node.closest('.fancybox__content')
        if (fancyboxContent) {
            const closeBtn = fancyboxContent.querySelector('.is-close-btn')
            if (closeBtn) {
                closeBtn.click()
            }
        }
    }

    function openThanks() {
        const thanksOpen = document.querySelector('[data-element="modal-thanks-open"]')
        if (thanksOpen) {
            thanksOpen.click()
        }
    }

    const modalThanksButton = document.querySelector('[data-element="modal-thanks-button"]')
    if (modalThanksButton) {
        modalThanksButton.addEventListener('click', () => closeModalForm(modalThanksButton))
    }

});
